import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Camera } from "lucide-react";
import { useLang, api } from "../store";
import { PageHead } from "../components/Reveal";
import Footer from "../components/Footer";

export default function Gallery() {
  const { lang, t } = useLang();
  const [photos, setPhotos] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setPhotos(r.data)).catch(() => setPhotos([]));
  }, []);

  return (
    <div className="min-h-screen" data-testid="gallery-page">
      <PageHead kicker="35MM · STILLS" title={t("gallery.title")} sub={t("gallery.sub")} />

      <div className="mx-auto max-w-[1600px] px-6">
        {photos.length === 0 ? (
          <div className="flex flex-col items-start gap-4 rounded border border-white/10 bg-[#0e1014] p-12" data-testid="gallery-empty">
            <Camera size={28} className="text-amber-500" />
            <p className="font-serif-it max-w-xl text-xl italic leading-relaxed text-slate-400">{t("gallery.empty")}</p>
          </div>
        ) : (
          <div className="columns-2 gap-4 md:columns-3" data-testid="gallery-grid">
            {photos.map((p) => (
              <button
                key={p.id}
                onClick={() => setLightbox(p)}
                data-testid={`gallery-photo-${p.id}`}
                className="poster-frame group relative mb-4 block w-full break-inside-avoid overflow-hidden rounded border border-white/10"
              >
                <img src={p.image} alt={lang === "it" ? p.title_it : p.title_en} loading="lazy" className="w-full object-cover" />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 to-transparent p-3 pt-8 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <p className="font-display text-left text-sm uppercase tracking-wide">{lang === "it" ? p.title_it : p.title_en}</p>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      <AnimatePresence>
        {lightbox && (
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[80] flex items-center justify-center bg-black/92 p-6"
            onClick={() => setLightbox(null)}
            data-testid="gallery-lightbox"
          >
            <motion.figure
              initial={{ scale: 0.94 }} animate={{ scale: 1 }} exit={{ scale: 0.94 }}
              className="max-h-[88vh] max-w-4xl"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={lightbox.image} alt="" className="max-h-[76vh] w-full rounded object-contain" />
              <figcaption className="font-display mt-4 uppercase tracking-wide">{lang === "it" ? lightbox.title_it : lightbox.title_en}</figcaption>
            </motion.figure>
            <button className="absolute right-6 top-6 text-slate-400 hover:text-white" onClick={() => setLightbox(null)} data-testid="lightbox-close"><X size={26} /></button>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="mt-24" />
      <Footer />
    </div>
  );
}
